import { z } from "zod";
import { durationInHoursZodSchema } from "../date-time/time-spans";
import { priceZodSchema } from "../prices/price";
import { amountZodSchema } from "../units-and-quantities/amount";
import { contentBlockZodSchema } from "./content-block";
import { giftCardPriceSettingsZodObject } from "./gift-card-price-settings";

const giftCardZodObject = z.object({
    _type: z.literal("GIFTCARD"),
    price: priceZodSchema,
    priceSettings: giftCardPriceSettingsZodObject.optional(),
    /**
     * Amount of stock item required for 1 sku \
     *
     * E.g. A shirt could have 5 pcs in stock \
     * A sku could be a two-pack of shirts. \
     * When you buy 1 of the sku, the amount (below) is 2 \
     * Two shirts in stock is required to buy one of the sku
     * @type {Amount}
     */
    amount: amountZodSchema,
    valid: durationInHoursZodSchema,
    contentBlocks: z.array(contentBlockZodSchema),
});

type GiftCard = z.infer<typeof giftCardZodObject>;

const _giftCardFactoryParamsZodObject = giftCardZodObject.omit({
    _type: true,
});
type FactoryParams = z.infer<typeof _giftCardFactoryParamsZodObject>;
const giftCardFactory = (params: FactoryParams): GiftCard => {
    const { price, valid, amount, contentBlocks, priceSettings } = params;
    const result: GiftCard = {
        _type: "GIFTCARD",
        price,
        valid,
        amount,
        contentBlocks,
        priceSettings,
    };
    return result;
};

export { giftCardFactory, giftCardZodObject };
export type { GiftCard };
